import { render, staticRenderFns } from "./ClientUnsubscribeReasonSelector.vue?vue&type=template&id=efc74f48&scoped=true"
import script from "./ClientUnsubscribeReasonSelector.vue?vue&type=script&lang=js"
export * from "./ClientUnsubscribeReasonSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efc74f48",
  null
  
)

export default component.exports